import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Calendar } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

export const EditPeriodModal = ({ period, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: period.name,
    end_date: period.end_date
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.put(`${API}/periods/${period.id}`, formData, getAuthHeaders());
      toast.success('Período atualizado com sucesso!');
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao atualizar período');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[450px]" data-testid="edit-period-modal">
        <DialogHeader>
          <DialogTitle data-testid="edit-period-modal-title">
            <div className="flex items-center gap-2">
              <Calendar className="w-5 h-5" />
              Editar Período
            </div>
          </DialogTitle>
          <DialogDescription>Atualize o nome ou estenda o prazo do período</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="edit-period-form">
          <div className="space-y-2">
            <Label htmlFor="name">Nome do Período</Label>
            <Input
              id="name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              data-testid="period-name-input"
              className="input-focus"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="start_date">Data de Início (não editável)</Label>
            <Input
              id="start_date"
              type="datetime-local"
              value={period.start_date}
              disabled
              className="input-focus opacity-50"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="end_date">Data de Término (estender prazo)</Label>
            <Input
              id="end_date"
              type="datetime-local"
              value={formData.end_date}
              onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
              required
              data-testid="period-end-input"
              className="input-focus"
            />
          </div>
          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 btn-transition"
              data-testid="cancel-period-button"
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              disabled={loading}
              className="flex-1 btn-transition"
              data-testid="submit-period-button"
            >
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditPeriodModal;
